import {faDiamondTurnRight} from '@fortawesome/pro-solid-svg-icons';

import {PageLayout} from '../../_old/PageLayout/PageLayout';
import {Heading} from '../Heading';
import {Text} from '../Text';

import {ErrorScreenContainer, ErrorScreenIcon} from './common';

export function NotFoundErrorScreen(): React.JSX.Element {
  return (
    <PageLayout.Main>
      <PageLayout.Content>
        <ErrorScreenContainer>
          <ErrorScreenIcon icon={faDiamondTurnRight} className="text-amber9" />

          <div className="text-center text-slate12">
            <Heading as="title" tag="h1">
              Page not found
            </Heading>

            <Text>The page that you are looking for does not exist.</Text>
          </div>
        </ErrorScreenContainer>
      </PageLayout.Content>
    </PageLayout.Main>
  );
}
